module.exports = __webpack_public_path__ + "media/npc_dota_hero_beastmaster.a3ffd415.webm";